<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button *ngIf="!visibilitySpinner" [disabled]="!exportIsAvailable()" class="btn btn-outline-success" title="Exportar" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<app-especie-eppo-popup (selected)="onAcceptDialogEspecieEppo($event)" [esImportacion]="true"></app-especie-eppo-popup>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Buscador de Productos</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Desde</label>
                                    <p-calendar formControlName="FechaDesde" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Hasta</label>
                                    <p-calendar formControlName="FechaHasta" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpTipo">Tipo de Solicitud</label>
                                    <ng-select [items]="listTipoSolicitud"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoSolicitud"
                                               loadingText="Cargando..."
                                               [readonly]="!listTipoSolicitud || listTipoSolicitud.length === 0"
                                               [loading]="!listTipoSolicitud || listTipoSolicitud.length === 0"
                                               notFoundText="Tipo no encontrado"
                                               placeholder="-- Seleccione un Tipo --"
                                               clearAllText="Eliminar selección">

                                        <ng-template ng-label-tmp let-item="item">
                                            <img src="/assets/images/TipoSolicitud/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                            <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="/assets/images/TipoSolicitud/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                            <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="intEstado">Estado de Solicitud</label>
                                    <ng-select [items]="listEstado"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdEstadoSolicitud"
                                               loadingText="Cargando..."
                                               [readonly]="!listEstado || listEstado.length === 0"
                                               [loading]="!listEstado || listEstado.length === 0"
                                               notFoundText="Estado no encontrado"
                                               placeholder="-- Seleccione un Estado --"
                                               clearAllText="Eliminar selección">

                                        <ng-template ng-label-tmp let-item="item">
                                            <img src="/assets/images/EstadoSolicitud/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                            <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="/assets/images/EstadoSolicitud/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                            <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigo">Nº Solicitud</label>
                                    <input formControlName="Codigo" name="Codigo" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpPais">País Origen</label>
                                    <ng-select [items]="listPais"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPais"
                                               loadingText="Cargando..."
                                               [readonly]="!listPais || listPais.length === 0"
                                               [loading]="!listPais || listPais.length === 0"
                                               notFoundText="País no encontrado"
                                               placeholder="-- Seleccione un País --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectPais()">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpProvincia">Provincia Inspección</label>
                                    <ng-select [items]="listProvincias"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvincia"
                                               loadingText="Cargando..."
                                               [readonly]="!listProvincias || listProvincias.length === 0"
                                               [loading]="!listProvincias"
                                               notFoundText="Provincia no encontrada"
                                               placeholder="-- Seleccione una Provincia --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectProvincia()">
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="intEstado">Punto de Inspección</label>
                                    <ng-select [items]="listPuntoInspeccion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPuntoInspeccion"
                                               loadingText="Cargando..."
                                               [readonly]="!form.value.IdProvincia || !listPuntoInspeccion || listPuntoInspeccion.length === 0"
                                               [loading]="(!listPuntoInspeccion || listPuntoInspeccion.length === 0) && (form.value.IdProvincia !== null)"
                                               notFoundText="Punto Inspección no encontrado"
                                               placeholder="-- Seleccione un PIF --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Grupo</label>
                                    <ng-select [items]="listGrupo"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdGrupo"
                                               loadingText="Cargando..."
                                               [readonly]="!listGrupo || listGrupo.length === 0"
                                               [loading]="!listGrupo || listGrupo.length === 0"
                                               notFoundText="Grupo no encontrado"
                                               placeholder="-- Seleccione un Grupo --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectGrupo()">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="">Forma</label>
                                    <ng-select [items]="listForma"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdForma"
                                               loadingText="Cargando..."
                                               [readonly]="!listForma || listForma.length === 0"
                                               [loading]="(!listForma || listForma.length === 0) && (form.value.IdGrupo !== null)"
                                               notFoundText="Forma no encontrada"
                                               placeholder="-- Seleccione una Forma --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectForma()">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigo">Código Taric</label>
                                    <input formControlName="CodigoTaric" name="CodigoTaric" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="10">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="intPais">Código Eppo</label>
                                    <div class="input-group">
                                        <input readonly title="" formControlName="CodigoEppo" class="form-control" id="" type="text">
                                        <span class="input-group-btn">
                                            &nbsp;<button [disabled]="!habilitarBusquedaEppo" name="btnSearchCodigoEppo" class="btn btn-list btn-secondary" type="button"
                                                          title="Buscar Código Eppo" (click)="onSearchCodigoEppo()">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpDescripcion">Nombre Común</label>
                                    <input formControlName="NombreComun" name="NombreComun" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="intResultadoEnvioMuestrasLaboratorio">Estado envío de muestras</label>
                                    <ng-select [items]="listResultadoEnvioMuestrasLaboratorio"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdResultadoEnvioMuestrasLaboratorio"
                                               loadingText="Cargando..."
                                               [readonly]="!listResultadoEnvioMuestrasLaboratorio || listResultadoEnvioMuestrasLaboratorio.length === 0"
                                               [loading]="!listResultadoEnvioMuestrasLaboratorio"
                                               notFoundText="Resultado no encontrado"
                                               placeholder="-- Seleccione un Resultado --"
                                               clearAllText="Eliminar selección">

                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <img src="{{ item.Id | IconoResultadoEnvioMuestraLaboratorio }}" style="width:24px;vertical-align:middle" />
                                            <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                                        </ng-template>

                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="EsPredua">Pre-DUA</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="EsPredua"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpEnvioMuestras">Envío de muestras</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="TieneEnvioDeMuestras"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpMatriculas">Matrículas</label>
                                    <input formControlName="Matriculas" name="Matriculas" title="" class="form-control" id="inpMatriculas" type="text" value="" maxlength="50">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigoTraces">Código Traces</label>
                                    <input formControlName="CodigoTraces" name="CodigoTraces" title="" class="form-control" id="inpCodigoTraces" type="text" value="" maxlength="10">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpExportador">Exportador</label>
                                    <input formControlName="Exportador" name="Exportador" title="" class="form-control" id="inpExportador" type="text" value="" maxlength="10">
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div *ngIf="isCollapsed" class="form-group-0 float-left ui-fontgris">
                                    Pulse sobre "<i class="fa fa-caret-down"></i>" para desplegar los criterios de búsqueda
                                </div>
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="button" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Productos
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultProductos?.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                 [columns]="cols" sortField="Codigo" [rows]="resultProductos?.PageSize" [totalRecords]="resultProductos?.TotalCount" [loading]="loading"
                                 styleClass="table table-responsive-sm  table-striped table-sm" [ngClass]="displayGridHidden(resultProductos?.ResultList)" rowExpandMode="single">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th nowrap scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='Image'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr>

                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="(col.field!=='Link' && col.field!=='Image' && col.field!=='FechaEnvio' && col.field!=='FechaInspeccion' && col.field!=='FechaLlegada' && col.field!=='EsPredua' && col.field!=='PesoNeto')">{{rowData[col.field]}}</span>
                                        <span *ngIf="col.field==='FechaEnvio'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                        <span *ngIf="col.field==='FechaInspeccion'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                        <span *ngIf="col.field==='EsPredua'">{{rowData[col.field] | siNo}}</span>
                                        <span *ngIf="col.field==='PesoNeto'">{{rowData[col.field] | number:'1.3-3':'es'}}</span>
                                        <span *ngIf="col.field==='FechaLlegada'">{{rowData[col.field] | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                                        <span *ngIf="col.field==='Image'">
                                            <!--***ICONOS***-->
                                            <img class="estado-icono" src="{{ null | IconoEstadoSolicitud}}" container="body" ngbTooltip="{{rowData['TipoSolicitud']}}" />
                                            <label class="codigo-icono" container="body" ngbTooltip="{{rowData['TipoSolicitud']}}">{{rowData['CodigoTipoSolicitud']}}</label>
                                            <img class="estado-icono" src="{{rowData['IdEstadoSolicitud'] | IconoEstadoSolicitud}}" container="body" ngbTooltip="{{rowData['EstadoSolicitud']}}" />
                                            <img class="predua-icono" src="{{rowData['EsPredua'] | IconoPreduaSolicitud}}" container="body" ngbTooltip="{{rowData['EsPredua'] | preduaNoPredua}}" />
                                            <img *ngIf="rowData['IdResultadoEnvioMuestrasLaboratorio']" class="estado-icono" src="{{rowData['IdResultadoEnvioMuestrasLaboratorio'] | IconoResultadoEnvioMuestraLaboratorio}}" container="body" ngbTooltip="{{rowData['DescripcionIdResultadoEnvioMuestrasLaboratorio']}}" />
                                        </span>

                                        <div *ngIf="col.field==='Link'" class="btn-group">
                                            <div *ngIf="checkEdit(rowData)">
                                                <button (click)="onEdit(rowData)" type="button" ngbTooltip="Editar"
                                                        class="btn btn-sm btn-warning">
                                                    <span class="fa fa-edit"></span>

                                                </button>
                                            </div>
                                            <div *ngIf="!checkEdit(rowData)">
                                                <button (click)="onEdit(rowData)" type="button" ngbTooltip="Consultar" placement="right"
                                                        class="btn btn-sm btn-info">
                                                    <span class="fa fa-search"></span>

                                                </button>
                                            </div>

                                            <div *ngIf="checkDelete(rowData)">
                                                <button (click)="onDelete(rowData)" type="button" ngbTooltip="Eliminar"
                                                        class="btn btn-sm btn-danger">
                                                    <span class="fa fa-remove"></span>

                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </ng-template>

                        </p-table>
                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
